import axios from "axios";
import makeApiCall from "./axiosIndex";
const contractorsApis = {
  fetchContractor: (): Promise<any> =>
    makeApiCall<any>({ method: "get", url: "/buyer/fetchContractor" }),
  fetchContractorWithPagination: (params: any): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchContractorsWithPagination",
      method: "get",
      params,
    });
  },
  deleteContractorById: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "delete",
      url: `/buyer/deleteContractorById?id=${id}`,
    }),
  createContractor: (data: any): Promise<any> =>
    makeApiCall<any>({ method: "post", url: "/buyer/createContractor", data }),
  updateContractorById: (id: any, data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/buyer/updateContractorById?id=${id}`,
      data,
    }),
  fetchContractorById: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/buyer/fetchContractorById?id=${id}`,
    }),
  fetchContractorBySiteId: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: "/buyer/fetchContractorBySiteId",
      data,
    }),
  // application access APIs
  allowApplicationAccess: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "patch",
      url: `/buyer/allowApplicationAccessToContractorById?id=${id}`,
    }),
  removeApplicationAccess: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "patch",
      url: `/buyer/removeApplicationAccessToContractorById?id=${id}`,
    }),
  //ocr contractor gst details
  verifyGstDetails: (data: { orgName: string; gstin: string }): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: "/verifyLegalDetails",
      data,
    }),

  // uploadGstFile: async (file: File): Promise<any> => {
  //   const formData = new FormData();
  //   formData.append("file", file);

  //   return makeApiCall<any>({
  //     method: "post",
  //     url: "http://4.188.90.170:8019/gst/process",
  //     data: formData,
  //     // headers: {
  //     //   "Content-Type": "multipart/form-data",
  //     // },
  //   });
  // },

  uploadGstFile: async (file: File): Promise<any> => {
    const formData = new FormData();
    formData.append("file", file);

    let url=`${process.env.REACT_APP_GST_URL}`;
    return axios.post(`${url}`, formData, {
      // headers: {
      //   "Content-Type": "multipart/form-data",
      // },
    });
  },
};

export default contractorsApis;
